import React from 'react'
import config from '~config'

import LogoIcon from '~assets/brand/icon_raw.svg?component'
import { HeaderFirstAction as FirstAction, HeaderSpace as Space, Header, Button } from '~ui';
import { Button as ProfileButton } from '~co/user/profile'
import Title from './title'
import Close from './close'

export default (props)=>{
    return (
        <Header data-no-shadow data-static>
            <FirstAction>
                <Button variant='ghost'
                    as='a'
                    href={config.links.app.index}
                    target='_blank'
                    title='Raindrop.io'>
                    <LogoIcon className={'ui-add-logo'} />
                </Button>
            </FirstAction>
    
            <Title {...props} />
    
            <Space />

            <ProfileButton />
    
            <Close {...props} />
        </Header>
    )
}